export default {
  forgot_password_confirm: {
    title: '패스워드 초기화',
    required_code: '코드는 필수 항목입니다.',
    required_password: '패스워드는 필수 항목입니다.',
    max_length_16: '패스워드는 8~16자여야 합니다.',
    // no_blank: "",
    no_password_match: '패스워드가 일치하지 않습니다.',
    reset_password: '패스워드 재설정',
    caution: '화면을 아직 닫지 마세요',
    double_check_text: '@:login.double_check_text',
    password_reset_text: '입력하신 이메일 주소로 보낸 메일 안의 확인 코드를 아래 양식에 입력하고, 새로운 패스워드를 설정해 주세요.',
    verification_code: '확인 코드',
    mail_send_code: '메일로 보낸 코드',
    password: '패스워드',
    new_password: '새로운 패스워드',
    password_display: '패스워드 표시',
    password_no_display: '패스워드 미표시',
    password_check: '새로운 패스워드(확인)',
    submit: '설정하기',
  },
}
